// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.msg-alert {
    float: left;
    width: 100%;
}
.logo-app {
    float: right;
    width: 50px;
}
.logo-app img {
    width: 100%;
}

.input-group input{
    font-size: 14px;
}

.img-login img {
    width: 75%;
}
.img-login {
    text-align: center;
    padding: 10px 0;
    padding-bottom: 0;
}

.img-login span {
    margin: 18px 0;
    display: block;
    font-size: 30px;
    color: #af2626;
}

.btn-success {
    color: #fff;
    background-color: #3170f9 !important;
    border-color: #3170f9 !important;
    box-shadow: none;
}

.forgot-psw {
    color: red;
}
.forgot-psw:hover {
    color: rgb(209, 0, 0);
}
h4 {
    color: black
}
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;AACzB;AACA;IACI;AACJ;AACA;IACI,aAAa;IACb,wBAAwB;AAC5B","sourcesContent":["span.msg-alert {\n    float: left;\n    width: 100%;\n}\n.logo-app {\n    float: right;\n    width: 50px;\n}\n.logo-app img {\n    width: 100%;\n}\n\n.input-group input{\n    font-size: 14px;\n}\n\n.img-login img {\n    width: 75%;\n}\n.img-login {\n    text-align: center;\n    padding: 10px 0;\n    padding-bottom: 0;\n}\n\n.img-login span {\n    margin: 18px 0;\n    display: block;\n    font-size: 30px;\n    color: #af2626;\n}\n\n.btn-success {\n    color: #fff;\n    background-color: #3170f9 !important;\n    border-color: #3170f9 !important;\n    box-shadow: none;\n}\n\n.forgot-psw {\n    color: red;\n}\n.forgot-psw:hover {\n    color: rgb(209, 0, 0);\n}\nh4 {\n    color: black\n}\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
